export const timeConvert12hrTo24hr = (time: string): string => {
  let [hour, secondPart] = time.split(":");
  if (!(hour && secondPart)) {
    throw new Error("Invalid time format");
  }
  const meridiem = secondPart.slice(-2);
  const minute = secondPart.slice(0, 2);
  if (hour === "12") {
    hour = "00";
  }
  if (meridiem === "am") {
    return `${hour}:${minute}`;
  }
  return `${Number.parseInt(hour, 10) + 12}:${minute}`;
};

export const timeConvert12hrToMinutes = (time: string): number => {
  let [hour, secondPart] = time.split(":");
  if (!(hour && secondPart)) {
    throw new Error("Invalid time format");
  }
  const meridiem = secondPart.slice(-2);
  const minute = secondPart.slice(0, 2);
  if (meridiem === "am" && hour === "12") {
    hour = "0";
  }
  return (
    (Number.parseInt(hour, 10) + (meridiem === "am" ? 0 : 12)) * 60 +
    Number.parseInt(minute, 10)
  );
};

export const timeConvert24hrTo12hr = (time: string): string => {
  const [rawHour, rawMinute] = time.split(":");
  if (!(rawHour && rawMinute)) {
    throw new Error("Invalid time format");
  }
  const minute = rawMinute.slice(0, 2);
  const hour = Number.parseInt(rawHour, 10);
  if (hour === 0) {
    return `12:${minute}am`;
  }
  if (hour < 12) {
    return `${hour}:${minute}am`;
  }
  if (hour === 12) {
    return `12:${minute}pm`;
  }
  return `${hour - 12}:${minute}pm`;
};
